import { updateItemInCollection } from "directus/src/operations";

export async function updateOpeningApplicant({ applicantId, item }) {
    try {
        const query = {
            fields: [
                "id",
                "opening",
                "employee",
                "experience",
                "description",
                "resume_url",
                "is_selected",
            ],
        };

        const data = await updateItemInCollection(
            "opening_applicants",
            applicantId,
            item,
            query
        );

        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}
